import { action } from "satcheljs";

const onCloseSearch: () => {} = action("onCloseSearch");
export default onCloseSearch;
